export default {
  id: "recmUBNcwjOKAGc13",
  name: "Episode I: Welcome AF",
  products: ["rec18T7VqM6wSXvq0", "recMs9PjrASr12eNo"],
  active: true,
  charity: {
    id: "rechRx1JKipFnYINc",
    name: "Adore Ministries",
    episodes: ["recmUBNcwjOKAGc13"],
    bio:
      "Adore is a community of Catholic lay missionaries, single men and women, married couples, and families, called by their Baptism to mission. They seek to love and walk with our neighbors, sharing the Gospel joyfully, living our faith, and growing in loving relationship with God and each other.",
    twitter_url: "https://twitter.com/adoreministries",
    facebook_url: "https://www.facebook.com/adoreministries",
    instagram_url: "https://www.instagram.com/adoreministries/",
    website: "https://adoreministries.com/",
    photo: [
      {
        id: "att7LCaEXKxAyv4K4",
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711598400000/Nj1HlWDBU-igoQsUhtPfOA/1fM-TrCEJ10upc7MRWzmMJsgPQJ-wxhZ2WUzyxMB4XN9upgy_7Xtn_EayNDIp9K3pvEVZ7yu3fP1yvYolBKHYbpOS2v-fJ0W0Pyr1y6pDYA/LWMxcAcGueOrqae1vP8T7CDYexe0YBORfZUIoSOsChw",
        filename: "adore.png",
        size: 25154,
        type: "image/png",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711598400000/LKeqRYTSWpE5GGPv8H6f-Q/zS4rI857MYZD47TcyrBaoLL65C1kbx0z4Fd9v7tYePESnX7SJ8ZBe-6-5loPrTtn-0C5pjIvvO3SXz1dsxKY9Zhe93ARJTz5_cAgI5S07Zg/vH1_EGjIi-KthQLOk2stu8RW8Kzwryuq5YbGqHMXrrk",
            width: 52,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711598400000/alIGigFGMibEVtsw24eheA/TrBnVGd7zIVoLI6YD0gOqjNGysanWm2-DLL-BahmKbOjcn-SFlX7nBNQdVGNnOfTdZeMoXrVIAJKCFaoEL8uFgAbbw776gcVIE0DX0oys54/5mLvPg_eN0dydlLPvUW8WA4D8Ddm_EkwYFB2bkK7A8k",
            width: 517,
            height: 358
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711598400000/pXBO1PzYR-4ZLKri_LielA/E9kHIx9-Ufq-zaCYGZyGU06W4kYlDAXCUzIX8J9n5GUiZ9XHthXQnDtXV1qeivp01WOJrT8pMEyZeJns9p6mKnfN7EIf8fuDSeWPRk3LoN4/IAQfUfgb95xN0LyQ-SBupW4CNjLLF6owh2b6xdwTJ5E",
            width: 517,
            height: 358
          }
        }
      }
    ]
  },
  artist: {
    id: "rectdfGRemdfZBXzv",
    name: "David Leininger",
    episodes: ["recmUBNcwjOKAGc13"],
    bio:
      "I could spend hours talking about the merits of pizza. I don’t drink coffee, but I love coffee shops. I like good bourbon. I have a lot of tattoos. \n\nAs a co-creator of Catholic AF, I won’t be keeping the money from the designer portion. I’m going to put it back into Catholic AF so we can keep this going.",
    twitter_url: "https://twitter.com/davidleininger",
    website: "https://leininger.tech",
    photo: [
      {
        id: "attXGBk2dRkPUA2pO",
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/2ONyqCXc02hcndNsb5pCXg/-tTWJIA-r5QEC_q8qy3PRtbAFWRgdVxqc-LCtZj3UPntuiG8t2QHtRfEBzGR1lX3eBxSzaoJmLb8clKi0mTjI1EcbThculMAlPZnKmR_62Y/M1JnHoTWMu9lq-wUNxfa3PYswHkQlju_Gwl9Y4vDhkI",
        filename: "david.png",
        size: 277465,
        type: "image/png",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/nWYBG6Ls5_4EQQuB6zAv_Q/mCC64jPSMd4qM6zSPFzwhuSLTNkN3yNjuubfW5FO3XiXvJrbqkkkIMo9anBAM6yOZpEiPARmFEfRWU7PLZQI7f-T9fG6lWbBKjZR1XVy-CU/9AeYCD7wi-xbxwnSNNtbbV1eY-V-ULqWcAWq_KQAhMo",
            width: 52,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/vM_q6kQa2dhYs55KvRcfxQ/DVZ5jguWPCrBsVWKAgoGk2QFNpHLtuLDqpzMpYzXPCaA4grY9MsZPpeFrYKGhxK51xAun65dUpiOnl_ukJBk2hSd-38l4U37QTth7EWVihE/vR0QwzMzOsdAUFxb4u4kC8HOu0gFLysIjy43maAbfH0",
            width: 517,
            height: 358
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/2ONyqCXc02hcndNsb5pCXg/-tTWJIA-r5QEC_q8qy3PRtbAFWRgdVxqc-LCtZj3UPntuiG8t2QHtRfEBzGR1lX3eBxSzaoJmLb8clKi0mTjI1EcbThculMAlPZnKmR_62Y/M1JnHoTWMu9lq-wUNxfa3PYswHkQlju_Gwl9Y4vDhkI",
            width: 517,
            height: 358
          }
        }
      }
    ]
  }
};
